
import Vue from 'vue';
import Component from 'vue-class-component';

// Components
import VHeaderLogo from './VHeaderLogo.vue';
import VHeaderProfile from './VHeaderProfile.vue';

@Component({
    components: { VHeaderLogo, VHeaderProfile },
})
export default class VHeader extends Vue {}
